import "./styles.scss";

import React from "react";
import { Link } from "gatsby";
import { GatsbyImage, getImage } from "gatsby-plugin-image";

function OfferTile({ name, image, href }) {
  const photo = !!image && getImage(image?.node?.gatsbyImage);

  return (
    <Link to={href} className="offer-tile">
      <div className="offer-tile__image">
        {!!photo && (
          <GatsbyImage image={photo} alt={name} className="offer-tile__image" />
        )}
      </div>
      <p className="offer-tile__title">{name}</p>
    </Link>
  );
}

export default OfferTile;
